import { useEffect } from "react";

import useCustomSelector from "@redux/hooks/useCustomSelector";
import useActionCreator from "@redux/hooks/useActionCreator";

import { EmployeeState } from "@reducers/types/inventory/employee-state";

interface UseEmployeeGeneralInfo {
  employeesState: EmployeeState;
}

export const useEmployeeGeneralInfo = (
  id:number | null,
): UseEmployeeGeneralInfo => {
  const { inventoryActionsHandlers } = useActionCreator();
  const { fetchEmployeeGeneralInfoActionHandler } = inventoryActionsHandlers;


  const employeesState = useCustomSelector(
    (store) => store.inventory.employeesState,
  );

  useEffect(() => {
    if (id) {
      fetchEmployeeGeneralInfoActionHandler(`${id}`);
    }
  }, []);

  return {
    employeesState,
  };
};
